import { message } from "antd";
import { makeAutoObservable, runInAction } from "mobx";
import Subjects from "../../models/subjects";
import ITask from "../../models/task";
import DictionariesService from '../../services/dictionaries';
import FilesService from "../../services/files-service";
import { SaveTaskRequest, TaskService } from "../../services/task-service";
import ImageUploaderStore from '../common/image-uploader';
import SourceFilterStore from '../common/source-filter';
import TagsEditorStore from '../common/tags-editor';
import NumberInKimWithThemeStore from './number-in-kim-with-theme';


export default class EditTaskStore {

    task: ITask | null;

    taskService: TaskService;
    source: SourceFilterStore;
    numberInKimWithTheme: NumberInKimWithThemeStore;
    photoUploader: ImageUploaderStore;
    solutionUploader: ImageUploaderStore;
    dictionariesService: DictionariesService;
    filesService: FilesService;

    tags: TagsEditorStore;
    answer?: string;
    text?: string;
    loading: boolean;
    step: number;

    constructor(subject: Subjects) {

        this.task = null;
        this.loading = false;
        this.step = 0;

        this.taskService = new TaskService();
        this.source = new SourceFilterStore(subject, false);
        this.numberInKimWithTheme = new NumberInKimWithThemeStore(subject);
        this.tags = new TagsEditorStore();

        this.photoUploader = new ImageUploaderStore(subject, true);
        this.solutionUploader = new ImageUploaderStore(subject, false);
        this.dictionariesService = new DictionariesService();
        this.filesService = new FilesService();

        makeAutoObservable(this);
    }

    loadTask(taskId: number | undefined) {

        if (!taskId) {
            message.error('Задача не найдена!');
            return;
        }

        try {

            this.loading = true;
            
            this.taskService.getById(taskId, (data: any) => {

                this.task = data as ITask;
                this.source.selectItem([this.task.source.id]);
                this.numberInKimWithTheme.selectNumberInKim(this.task.numberInKim.id);
                this.numberInKimWithTheme.theme.selectItem(this.task.theme.id);
                this.tags.setTags(this.task.tags);
                this.answer = this.task.answer;
                this.text = this.task.text;

                this.photoUploader.setTaskId(data['id']);
                this.solutionUploader.setTaskId(data['id']);

                this.loading = false;

            }, (error: string) => {
                message.error(error);
                this.loading = false;
            }

            );

        } catch (error) {
            runInAction(() => {
                message.error(error);
                this.loading = false;
            });
        }
    }

    changeStep(step: number): void {
        this.step = step;
    }

    getUrl(fileId: string): string {
        return this.filesService.getFileUrl(fileId);
    }

    changeAnswer(value: string) {
        this.answer = value;
    }

    changeText(value: string) {
        this.text = value;
    }

    save() {

        if (this.task?.id) {

            this.loading = true;

            const params: SaveTaskRequest = {
                source: this.source.selectedItemAsNumber,
                numberInKim: this.numberInKimWithTheme.numberInKim.selectedItemAsNumber,
                theme: this.numberInKimWithTheme.theme.selectedItemAsNumber,
                tags: this.tags.getTags,
                answer: this.answer,
                text: this.text
            };

            this.taskService.update(
                this.task?.id,
                params,
                () => {
                    this.loading = false;
                    message.success('Задача успешно отредактирована!');
                },
                (error: string) => {
                    this.loading = false;
                    message.error(`Ошибка при сохранении: ${error}`);
                }
            );
        }
    }

    deletePhoto(photoId: string, isMainPhoto: boolean) {

        //TODO сдеалать диалоговое окно с подтверждением

        if (!this.task) {
            return;
        }

        this.taskService.deletePhoto(
            isMainPhoto, this.task?.id, photoId, () => {

                if (isMainPhoto && this.task?.photoIds) {

                    const index = this.task.photoIds.indexOf(photoId, 0);
                    if (index > -1) {
                        this.task?.photoIds.splice(index, 1);
                    }
                } else if (!isMainPhoto && this.task?.solutionPhotoIds) {
                    const index = this.task.solutionPhotoIds.indexOf(photoId, 0);
                    if (index > -1) {
                        this.task?.solutionPhotoIds.splice(index, 1);
                    }
                }

                message.success("Фото успешно удалено");
            }
        );
    }
}